import { css } from '@emotion/core';

const globalStyles = css`
  body {
    background-color: whitesmoke;
    min-height: 100vh;
    color: black;
  }

  * {
    box-sizing: border-box;
  }
`;

export default globalStyles;
